<template>
  <div class="row">
    <div class="row-fluid chartLabel">
      <stats-card type="info"
        :title="infoCard.mainText1" :small-title="infoCard.littleText1"
        :title2="infoCard.mainText2" :small-title2="infoCard.littleText2"
        :title3="infoCard.mainText3" :small-title3="infoCard.littleText3"
        icon="nc-icon nc-alert-circle-i">
       </stats-card>
    </div>
    <div class="row-fluid chartLabel">
      <stats-card type="info"
        :title="routeCard.mainText1" :small-title="routeCard.littleText1"
        :title2="routeCard.mainText2" :small-title2="routeCard.littleText2"
        :title3="routeCard.mainText3" :small-title3="routeCard.littleText3"
        icon="nc-icon nc-sound-wave">
      </stats-card>
    </div>
    <div class="row-fluid chartLabel">
        <stats-card type="info"
        :title="stateCard.mainText1" :small-title="stateCard.littleText1"
        :title2="stateCard.mainText2" :small-title2="stateCard.littleText2"
        :title3="stateCard.mainText3" :small-title3="stateCard.littleText3"
        icon="nc-icon nc-settings">
      </stats-card>
    </div>
    <div>
      <div class="row-fluid chartArea">
        <highcharts id="speedChart" ref="high" :options="chartOptions"></highcharts>
      </div>
    </div>
  </div>
</template>
<script>
import Highcharts from "highcharts";
import { mapState } from "vuex";
import { Card, StatsCard } from "src/components/UIComponents";

export default {
  components: {
    Card,
    StatsCard
  },
  data() {
    return {
        footerHeight: Number,
        infoCard: {
            littleText1:'Vehículo',
            mainText1:'',
            littleText2:'',
            mainText2:'',
            littleText3:'',
            mainText3:'',
        },
        routeCard: {
            littleText1:'Distancia',
            mainText1:'',
            littleText2:'Vel. Max.',
            mainText2:'',
            littleText3:'',
            mainText3:'',
        },
        stateCard: {
            littleText1:'Batería',
            mainText1:'',
            littleText2:'Validez',
            mainText2:'',
            littleText3:'',
            mainText3:'',
        }
    };
  },
  watch: {
    routeChart() {
      this.chartOptions.series[0].data = this.routeChart;
      this.findMaxSpeed()
    },
    patenteSelected() {
        this.infoCard.mainText1 = this.patenteSelected
        this.infoCard.mainText3 = this.getGrupoFromVeh(this.patenteSelected).substring(0, 11);
    },
    distance() {
        this.routeCard.mainText1 = (this.positionLastInfo.distance/1000).toFixed(1) + " Km"
    },
    vmax() {
        this.routeCard.mainText2 = this.positionLastInfo.vmax + " Km/h"
    },
    ageGps() {
        this.stateCard.mainText2 = this.secondsToTime(this.positionLastInfo.positionAge)
    },
    vbat() {
        this.stateCard.mainText1 = this.positionLastInfo.vbat + " V"
    }
  },
  computed: {
    ...mapState(["patenteSelected", "positionLastInfo","grupos", "routeChart", "map", "marker"]),
    vbat() {
      return this.positionLastInfo.vbat
    },
    distance() {
      return this.positionLastInfo.distance
    },
    vmax() {
      return this.positionLastInfo.vmax
    },
    ageGps() {
      return this.positionLastInfo.positionAge
    },
    chartOptions(e) {
      return {
        time: {
          timezoneOffset: 3 * 60
        },
        chart: {
          height: "" + this.footerHeight + "px",
          // type: 'area'
          backgroundColor: null,
          borderWidth: 0,
          borderRadius: 0,
          plotBackgroundColor: null,
          plotShadow: false,
          plotBorderWidth: 0,
          margin: [0, 20, 30, 20],
          zoomType: "x",
          alignTicks: false
        },
        toolbar: {
          itemStyle: {
            margin: "0px 0px 0px 100px"
          }
        },
        legend: {
          borderWidth: 0,
          align: "left",
          verticalAlign: "top",
          layout: "vertical",
          x: 0,
          y: -10,
          itemHiddenStyle: {
            color: "#888"
          }
        },
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        xAxis: {
          type: "datetime",
          dateTimeLabelFormats: {
            minute: "%H:%M",
            hour: "%H:%M",
            day: "<b>%e. %b</b>",
            week: "<b>%e. %b</b>",
            month: "<b>%e. %b</b>",
            year: "%Y"
          },
          lineColor: "#99A9B9"
        },
        yAxis: {
          gridLineWidth: 0,
          title: { enabled: false, text: "" },
          labels: { enabled: false },
          maxPadding: 0.15,
          min: 0,
          minRange: 120
        },
        tooltip: {
          formatter() {
            var pointIndex = this.series.data.indexOf(this.point);
            // pointIndex = ( this.routeChart.length - 1 ) - pointIndex;

            var months_arr = [
              "En",
              "Feb",
              "Mar",
              "Abr",
              "May",
              "Jun",
              "Jul",
              "Ago",
              "Sep",
              "Oct",
              "Nov",
              "Dic"
            ];

            // Convert timestamp to milliseconds
            var date = new Date(this.point.options.x);
            var year = date.getFullYear();
            var month = months_arr[date.getMonth()];
            var day = date.getDate();
            var weekday = [
              "Dom,",
              "Lun,",
              "Mar,",
              "Mie,",
              "Jue,",
              "Vie,",
              "Sab,"
            ];
            var hours = date.getHours();
            var minutes = "0" + date.getMinutes();

            var seconds = "0" + date.getSeconds();

            // Display date time in MM-dd-yyyy h:m:s format
            var convdataTime =
              weekday[date.getDay()] +
              " " +
              day +
              ". " +
              month +
              ", " +
              year +
              " - " +
              hours +
              ":" +
              minutes.substr(-2) +
              ":" +
              seconds.substr(-2);

            var timeStr = pointIndex ? "<br/>" + convdataTime : "";

            e.syncMapToChartHover(
              this.point.options.lat,
              this.point.options.lng
            );

            // var yValStr;
            // yValStr = Highcharts.numberFormat(this.y, 0);

            return (
              "<b>Velocidad : " + this.point.y + " Km/h</b><br/>" + timeStr
            );
          }
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              symbol: "circle",
              radius: 4,
              states: {
                hover: {
                  enabled: true
                }
              }
            },
            lineWidth: 3,
            events: {
              //TODO
              // mouseOut: function(event) {if (pointMarker) pointMarker.setMap(null);}
            }
          }
        },
        credits: {
          enabled: false
        },
        series: [
          {
            showInLegend: false,
            type: "area",
            name: "Velocidad",
            data: this.routeChart
          }
        ]
      };
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    secondsToTime(secValue) {

        var Days = Math.floor(secValue/60/60/24);
        var remDays = (secValue/60/60/24) - Math.floor(secValue/60/60/24);
        var Hours = Math.floor(remDays*24);
        var remHours = (remDays*24) - Math.floor(remDays*24);
        var Minutes = Math.floor(remHours*60);

        if (!Minutes)
            var Seconds = Math.floor(remHours*60*60);

        if( Days>0)
            return  Days+" D "+Hours+" hr " //+Minutes+" '"

        if (Hours >0)
            return Hours+" hr "+Minutes+" '"

        if (Minutes >0)
            return Minutes+" min"

        return Seconds+" seg"

    },
    getGrupoFromVeh(pat) {
      var gr;
      var ve;
      for (gr = 0; gr < this.grupos.length; gr++) {
        for (ve = 0; ve < this.grupos[gr].grupos_vehiculos.length; ve++) {
            if (pat == this.grupos[gr].grupos_vehiculos[ve].veh_id) {
                return this.grupos[gr].grupo_nombre
            }
        }
      }
      return ''
    },
    syncMapToChartHover(lat, lng) {
      if (this.map) {
        var logLatlng = new google.maps.LatLng(lat, lng);
        this.marker.setPosition(logLatlng);
        this.marker.setMap(this.map);
      }
    },
    handleResize() {
      let windowWidth = window.innerWidth;
      this.footerHeight = document.getElementById("footer").offsetHeight;
      let chartWidth = windowWidth - 760;
      document.getElementById("speedChart").style.width = chartWidth + "px";
    },
    findMaxSpeed(){
        var puntosVelMax = []
        let velMax = this.positionLastInfo.vmax

        for (let i = 0; i < this.routeChart.length; i++) {
          if (this.routeChart[i].y == velMax) {
            let puntoMax = {
              indice: i,
              obj: this.routeChart[i]
            }
            puntosVelMax.push(puntoMax)
          }
        }

        for (let i = 0; i < puntosVelMax.length; i++) {
            this.chartOptions.series[0].data[puntosVelMax[i].indice].marker = {
              enabled: true,
              symbol: "diamond",
              fillColor: '#FF0000',
              lineWidth: 2,
              radius: 6,
              states: {
                hover: {
                    enabled: true,
                    fillColor: '#FF0000'
                }
              }
            }
        }

    }
  }
};
</script>

<style scoped>
h1 {
  color: aliceblue;
}

h4 {
  color: aliceblue;
}

.row {
  margin: 0px;
}

.row-fluid {
  content: "";
  clear: both;
  display: table;
  line-height: 100%;
}

.chartLabel {
  padding: 10px;
  padding-bottom: 10px;
  float: left;
  margin: -5px;
  /* border-right: 2px solid;
   border-color: aliceblue; */
  margin-top: 0;
}

.chartArea {
  position: fixed;
  bottom: 0;
}

.card {
  background-color: rgb(47, 47, 47);
  color: #d6d2c8;
  min-width: 240px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 1);
}
</style>
